import { CASINO_BANNER_ASSETS } from '@/config/casino'
import { Button } from '@/components/ui/button'

export function CasinoHeroBanners() {
	return (
		<section className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
			<div className='relative flex min-h-[220px] items-center overflow-hidden rounded-2xl bg-gradient-to-r from-background via-[hsl(var(--accent-pink)/0.25)] to-[hsl(var(--accent-pink)/0.5)] px-6 py-8 sm:min-h-[260px] sm:px-8'>
				<div className='pointer-events-none absolute -right-10 top-1/2 h-80 w-80 -translate-y-1/2 opacity-95 sm:-right-12 sm:h-96 sm:w-96 lg:h-[26rem] lg:w-[26rem]'>
					<img src={CASINO_BANNER_ASSETS.depositBonus} alt='' className='h-full w-full object-contain' />
				</div>
				<div className='relative z-10 flex max-w-[55%] flex-col gap-3'>
					<img src='/images/logo.png' alt='Bets cycle' className='h-7 w-auto object-contain object-left sm:h-8' />
					<div className='flex flex-col gap-1'>
						<span className='text-sm italic tracking-[-0.21px] text-muted-foreground'>Deposit bonus</span>
						<span className='text-4xl font-bold leading-none tracking-[-0.2px] text-foreground sm:text-5xl'>200%</span>
						<span className='text-2xl font-semibold tracking-[-0.16px] text-foreground sm:text-3xl'>up to $1000</span>
					</div>
				</div>
			</div>

			<div className='relative flex min-h-[220px] items-center overflow-hidden rounded-2xl bg-background px-6 py-8 sm:min-h-[260px] sm:px-8'>
				<span
					className='pointer-events-none absolute inset-0'
					style={{
						background: 'radial-gradient(ellipse 90% 70% at 72% 50%, hsl(var(--primary) / 0.25) 0%, hsl(var(--primary) / 0.09) 32%, transparent 68%)',
					}}
				/>
				<span
					className='pointer-events-none absolute inset-0 opacity-30'
					style={{
						background:
							'conic-gradient(from 180deg at 72% 50%, transparent 0deg, hsl(var(--primary)) 14deg, transparent 28deg, transparent 72deg, hsl(var(--primary)) 86deg, transparent 100deg, transparent 144deg, hsl(var(--primary)) 158deg, transparent 172deg, transparent 216deg, hsl(var(--primary)) 230deg, transparent 244deg, transparent 288deg, hsl(var(--primary)) 302deg, transparent 316deg)',
					}}
				/>
				<span className='pointer-events-none absolute right-[8%] top-1/2 h-[280px] w-[280px] -translate-y-1/2 rounded-full bg-primary opacity-55 blur-[100px] sm:right-[6%] sm:h-[320px] sm:w-[320px]' />
				<div className='pointer-events-none absolute inset-0 bg-gradient-to-r from-background from-35% via-background/70 via-55% to-transparent' />
				<div className='pointer-events-none absolute -right-10 top-1/2 z-[1] h-80 w-80 -translate-y-1/2 sm:-right-12 sm:h-96 sm:w-96 lg:h-[26rem] lg:w-[26rem]'>
					<img src={CASINO_BANNER_ASSETS.loyaltyBoost} alt='' className='h-full w-full object-contain' />
				</div>
				<div className='relative z-10 flex max-w-[55%] flex-col gap-4'>
					<div className='flex flex-col gap-1'>
						<span className='text-sm tracking-[-0.21px] text-muted-foreground'>Loyalty</span>
						<span className='text-3xl font-bold italic leading-tight tracking-[-0.16px] text-foreground sm:text-4xl'>Loyalty Boost</span>
					</div>
					<Button type='button' variant='primary' size='lg' className='w-fit min-w-[140px]'>
						Join Now
					</Button>
				</div>
			</div>
		</section>
	)
}
